import React, { useState, useEffect, Fragment } from 'react';

import dayjs from 'dayjs';
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faToggleOn, faToggleOff, faEllipsisH } from '@fortawesome/free-solid-svg-icons'

export default function ViewportItemStatePopup(props) {

  // early return: no computation when popup was not shown yet
  if (! props.shown) return 

  const renderStats = () => {
    if (! props.stats) return null ;
    return ( 
      <Fragment>
        <tr className="separator"><td>össz. idő: </td>
          <td>
          { 
            dayjs.duration( Math.round(parseInt(props.stats.timeFull)/1000), "seconds")
            .format("Y [év] M [hónap] D [nap] HH:mm:ss" ).replace(/\b0 év\b/, '')
            .replace(/\b0 hónap\b/, '').replace(/\b0 nap\b/, '')
          } 
          </td>
        </tr>
        <tr><td>össz. táv: </td><td>{ Math.round(props.stats.distFull/100)/10.0 + ' km'} </td></tr>
        <tr><td>átlagtempó: </td><td>
        {(props.stats.paceAvg === Infinity ? "-" : Math.floor(props.stats.paceAvg) + ":" +
          String(Math.round((props.stats.paceAvg-Math.floor(props.stats.paceAvg))*60)).padStart(2, 0)) + ' perc/km' }
        </td></tr>
        <tr><td>állás idő: </td><td>{(props.stats.stopTime === Infinity ? "-" : Math.round(props.stats.stopTime/60000) ) + ' perc'}
        </td></tr>
      </Fragment>
    )

  }

  const renderBasicInfo = () => {
    const s = props.lastState
    if (! s) return null ;
    return ( 
      <Fragment>
        <tr className="separator"><td colSpan="2">utolsó adat: </td></tr>
        <tr><td colSpan="2">
          { 
            dayjs.utc( parseInt(s.time) ).local().format("YYYY-MM-DD HH:mm:ss" )
          }
        </td></tr>
        <tr><td>eltelt: </td><td>
          { // format ellapsed time: 
            dayjs.duration( Math.round( dayjs.utc().diff( parseInt(s.time) ) /1000  ), "seconds")
            .format("Y [év] M [hónap] D [nap] HH:mm:ss" ).replace(/\b0 év\b/, '')
            .replace(/\b0 hónap\b/, '').replace(/\b0 nap\b/, '')
          }
        </td></tr>
        <tr><td>GPS tempó: </td><td>
          {
            s.gpsPace === Infinity ? "-" : s.gpsPace.toFixed(0) + ":" +
            String(Math.round((s.gpsPace-Math.floor(s.gpsPace))*60)).padStart(2, 0)
          } perc/km
           </td></tr>
        <tr><td>magasság: </td><td>{ s.alt } m </td></tr>
        <tr className="separator"><td>aksi: </td><td>
          {Math.round(s.batteryV*100)/100 } V</td></tr>
        {/*<tr><td>térerő: </td><td> { Math.round(s.gsmSignal*100)/100 } % </td></tr> */}      
      </Fragment>
    )
    // <br/><div className="m-1 pl-1 pr-1 pt-2 pb-2 alert alert-info">' +
    //  <div className="viewport-note">' + props.viewportItemNotes + '</div>' +    // </div>'

  }
  const renderItemNotes = () => {
    if (props.viewportItemNotes) return (
      <tr className="separator"><td colSpan="2">
        <div className="viewport-note">' + props.viewportItemNotes + </div>
      </td></tr>
    )
    else return null
  }

  const renderControls = () => {
    if ( props.lastStateVisible )
      var stateVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOn} color="green"/> ;
    else
      stateVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOff} color="grey"/>
    if (props.trajectoryVisible )
      var trajectoryVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOn} color="green"/> ;
    else
      trajectoryVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOff} color="grey"/>
    if ( props.focused )
      var focusedMenuIcon = <FontAwesomeIcon icon={faToggleOn} color="green"/> ;
    else
      focusedMenuIcon = <FontAwesomeIcon icon={faToggleOff} color="grey"/>    
    return(
      <Fragment>
        {/*<tr className="separator"><td colSpan="2">
          <div className="popupSwitch">            
            <Link to={(props.focused ? "/" : 
                "/?focus=" + props.viewportItemKey) }>
              {focusedMenuIcon} &nbsp; kiemel (fókuszál)
            </Link>
          </div>
        </td></tr>
        <tr><td colSpan="2">
          <div className="popupSwitch"
             onClick={() => props.setLastStateVisibility()}>
            {stateVisibleMenuIcon} &nbsp; hol van          
          </div>
        </td></tr>
        <tr><td colSpan="2">
          <div className="popupSwitch"
             onClick={() => props.setTrajectoryVisibility()}>
            {trajectoryVisibleMenuIcon} &nbsp; megtett út
          </div>
        </td></tr>
  
        <tr><td colSpan="2">  
        </td></tr>
        */}
      </Fragment>
    )
  }

  // if (props.viewportItemId == 1356)  console.log('ViewportItemStatePopup render: ',  props.viewportItemKey)
  return (
    <div id="popup" className="ol-popup">
      <div id="popup-content">
        <table className="mini">
          <tbody>
            <tr><td colSpan="2"><strong> {props.displayName}</strong></td></tr>
            {renderBasicInfo()}
            {renderStats()}
            {renderControls()}
            {renderItemNotes()}
          </tbody>
        </table>
      </div>
    </div>
  )


}